import type { AttendanceResponse } from '$lib/api/types';

export type AttendanceActionKind = 'check-in' | 'check-out' | 'break-start' | 'break-end' | 'complete';

export type AttendanceActionState = {
	kind: AttendanceActionKind;
	label: string;
	description: string;
	disabled: boolean;
};

export function getAttendanceActionState(
	attendance: AttendanceResponse | null | undefined
): AttendanceActionState {
	if (!attendance?.checkInTime) {
		return {
			kind: 'check-in',
			label: '출근하기',
			description: '오늘 출근 기록이 아직 없습니다.',
			disabled: false
		};
	}

	if (!attendance.checkOutTime) {
		return {
			kind: 'check-out',
			label: '퇴근하기',
			description: '출근 처리됨 · 퇴근 기록이 필요합니다.',
			disabled: false
		};
	}

	if (attendance.autoCheckedOut) {
		return {
			kind: 'check-out',
			label: '퇴근 보정',
			description: '자동 퇴근 처리됨 · 실제 퇴근 시각으로 보정할 수 있습니다.',
			disabled: false
		};
	}

	return {
		kind: 'complete',
		label: '퇴근 완료',
		description: '오늘 출퇴근 기록이 완료되었습니다.',
		disabled: true
	};
}
